import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { withRouter } from 'react-router';

import { addUser, updateUser, setEditingUser, modifyUser, getUserById } from 'users/actions';

import { addGrowlMessage as addMsg } from 'messages/actions';

import { getRolesList } from 'containers/lists/actions';

import * as Common from 'common/components';
import UserForm from 'users/components/UserForm';

import { getCompany, getCurrentRole, getUser } from 'auth/selectors';
import { getVisibleRoles, getIsLoading } from 'lists/selectors';
import { getEditingUser } from 'users/selectors';
import { getVisibleSubcompanies } from 'subcompanies/selectors';

import { valueFromEvent } from 'lib/util';
import {
  ALL,
  assignableRoles,
  nextSelection,
  subcompaniesSaved,
  userPayload,
} from 'lib/subcompanyAccess';

class UsersFormContainer extends Component {
  state = { isValid: false, isSubmitted: false };

  componentWillMount = () => {
    this.props.getRolesList(this.props.company.id);
    this.props.setEditingUser();
    if (this.props.match.params.userId)
      this.props.getUserById(this.props.company.id, this.props.match.params.userId);
  };

  handleValueChange = (e) => this.props.modifyUser(valueFromEvent(e));

  // feature/acceso-subcompanias: "Todas" and specific subcompanies exclude each other.
  handleSubcompaniesChange = ({ target: { value } }) =>
    this.props.modifyUser({
      subcompaniesSelection: nextSelection(this.props.user.subcompaniesSelection, value),
    });

  // Root or the Administrador of the company (the back decides; this only shapes the form).
  canAssignSubcompanies = () =>
    !!((this.props.authUser && this.props.authUser.root) || (this.props.role && this.props.role.isAdmin));

  subcompanyOptions = () => [
    { value: ALL, label: this.props.t('users.fields.all_subcompanies') },
    ...(this.props.subcompanies || []).filter(Boolean).map((s) => ({ value: s.id, label: s.name })),
  ];

  handleSubmit = ({ isValid }) => {
    this.setState({ isSubmitted: true }, () => {
      if (!isValid) {
        return this.props.addMsg('error.verify', 'danger', 'common.error');
      }

      const body = userPayload(this.props.user, this.canAssignSubcompanies());
      const save = this.props.user.id
        ? this.props.updateUser(this.props.company.id, this.props.user.id, body)
        : this.props.addUser(this.props.company.id, body);

      return save
        .then(({ value }) => {
          // The answer must carry the list sent; if not, the back ignored it
          // (a back without this feature): say so and stay on the form.
          if (!subcompaniesSaved(body, value && value.user)) {
            return this.props.addMsg('error.users.subcompanies_not_saved', 'danger', 'common.error');
          }
          this.props.addMsg(value.message, 'success', 'common.success');
          this.props.history.push(`/companies/${this.props.company.id}/users`);
        })
        .catch((err) => this.props.addMsg(err.message, 'danger', 'common.error'));
    });
  };

  handleValidation = (isValid) => this.setState({ isValid });

  render = () => (
    <Common.PageWrapper fluid={true}>
      {/* <Common.PageHeader title={this.props.t("users.title")} /> */}
      <div className="col-12">
        <Common.Portlet
          title={
            this.props.t('menu.control_panel') +
            ' > ' +
            this.props.t('users.subtitle') +
            ' > ' +
            this.props.t(
              this.props.match.params.userId ? 'users.form_edit_title' : 'users.form_add_title'
            )
          }
          icon={this.props.match.params.userId ? 'pencil-square-o' : 'plus-circle'}
        >
          <UserForm
            id={this.props.user.id}
            companyId={this.props.company.id}
            roles={assignableRoles(this.props.roles, this.canAssignSubcompanies(), this.props.user.roleId)}
            canAssignSubcompanies={this.canAssignSubcompanies()}
            subcompanyOptions={this.subcompanyOptions()}
            handleSubcompaniesChange={this.handleSubcompaniesChange}
            t={this.props.t}
            values={this.props.user}
            isSubmitted={this.state.isSubmitted}
            isLoading={this.props.user.isSaving}
            isLoadingRoles={this.props.isLoadingRoles}
            handleSubmit={this.handleSubmit}
            handleValidation={this.handleValidation}
            handleValueChange={this.handleValueChange}
          />

          <Common.LoaderOverlay show={this.props.user.isLoading} />
        </Common.Portlet>
      </div>
    </Common.PageWrapper>
  );
}

const mapStateToProps = (state) => ({
  company: getCompany(state),
  user: getEditingUser(state),
  roles: getVisibleRoles(state),
  isLoadingRoles: getIsLoading(state),
  role: getCurrentRole(state),
  authUser: getUser(state),
  subcompanies: getVisibleSubcompanies(state),
});

const mapDispatchToProps = {
  getRolesList,
  setEditingUser,
  getUserById,
  addMsg,
  modifyUser,
  updateUser,
  addUser,
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  translate()
)(UsersFormContainer);



// WEBPACK FOOTER //
// src/modules/secured/modules/users/containers/UserFormContainer.js